export default __webpack_public_path__ + "static/media/back-arrow.c6ca9331.svg";